import AmexShopSmallEnrollOffer from './AmexShopSmallEnrollOffer';

export default AmexShopSmallEnrollOffer;
